import { Mark } from '@tiptap/core';

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    customBold: {
      /**
       * Set the font size
       */
      toggleCustomBold: (isActive: boolean, value: string) => ReturnType;
      /**
       * Unset the font size
       */
      setCustomBold: (name: string, value: string) => ReturnType;
      unsetCustomBold: () => ReturnType;
      unsetBold: () => ReturnType;
    };
  }
}

export const CustomBold = Mark.create({
  name: 'customBold',

  addOptions() {
    return {
      HTMLAttributes: {},
    };
  },

  addAttributes() {
    return {
      'data-spotstyle': {
        default: null,
        parseHTML: (element) => element.getAttribute('data-spotstyle'),
        renderHTML: (attributes) => {
          if (!attributes['data-spotstyle']) return {};
          return { 'data-spotstyle': attributes['data-spotstyle'] };
        },
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: 'span',
      },
      {
        tag: 'b',
        getAttrs: (node) => (node as HTMLElement).style.fontWeight !== 'normal' && null,
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return ['span', { ...this.options.HTMLAttributes, ...HTMLAttributes }, 0];
  },

  addCommands() {
    return {
      setCustomBold: (name, value) => {
        return ({ commands }) => {
          return commands.setMark(name, { 'data-spotstyle': value });
        };
      },
      unsetCustomBold: () => {
        return ({ commands }) => {
          return commands.unsetMark(this.name);
        };
      },
      unsetBold: () => {
        return ({ commands }) => {
          return commands.unsetMark(this.name);
        };
      },
      toggleCustomBold: (isActive: boolean, value: string) => {
        return ({ chain }) => {
          if (isActive) {
            return chain().focus().unsetMark('bold').setCustomBold('customBold', value).run();
          }

          return chain().focus().setMark('bold').unsetCustomBold().run();
        };
      },
    };
  },
});
